<template>
	<div class="home">
		<div class="movie">
			<video src="../assets/home/front_movie_02.mp4" loop autoplay muted playsinline></video>
		</div>
		<News />
		<CardItems
			title="事業・プロジェクト紹介"
			lead="豆蔵の代表的な4つの事業領域<br>「ビジネスプラットフォーム領域」<br class='under_display'>「エンベデッド領域」<br>「ロボット領域」<br class='under_display'>「DX・AIソリューション領域」について、<br>その魅力をお伝えします。"
		/>

		<PageIntro
			linkTitle="技術者としての成長"
			introduction="経営陣の技術力に対する想いや、<br class='over_display'>
    成長できる「5つの理由」について<br class='over_display'>
    紹介します。"
			:contentsImage="require('../assets/home/image02.jpg')"
			pageLink="/growth"
		/>

		<PagesIntro
			linkTitle="事業部インタビュー"
			introduction="ビジネスプラットフォーム領域、DX・AIソリューション領域、<br class='over_display'>ロボット領域で活躍するコンサルタントへのインタビュー。<br class='over_display'>各事業部の強みや、求める人物像などを語ります。"
		>
			<LinkCard
				title="ビジネスプラットフォーム領域"
				headline="クライアントの<br>課題の根幹から入ることで、<br>システムは真の目的を達成できる。"
				:image="require('../assets/home/image03.jpg')"
				:imageSp="require('../assets/home/image03_sp.jpg')"
				pageLink="/people_tadahiro"
			/>

			<LinkCard
				title="DX・AIソリューション領域"
				headline="AI、IoT、データサイエンス。<br>大学教授ともタッグを組み、<br>「知」の力でブレイクスルーを起こす。"
				:image="require('../assets/home/image04.jpg')"
				:imageSp="require('../assets/home/image04_sp.jpg')"
				pageLink="/people_satoshi"
			/>

			<LinkCard
				title="ロボット領域"
				headline="ソフト・メカ・エレキ。<br>全ての技術を融合させ、豆蔵でしか<br>つくれないロボットが誕生した。"
				:image="require('../assets/home/image05.jpg')"
				:imageSp="require('../assets/home/image05_sp.jpg')"
				pageLink="/people_seiji"
			/>
		</PagesIntro>
		<!-- <PagesIntro linkTitle="クロストーク"
    introduction="AI・データサイエンス領域の若手コンサルタントと<br class='over_display'>
    エンタープライズ、組込み領域のマネージャーによるクロストーク。<br class='over_display'>
    豆蔵での仕事のやりがいや、入社後の成長、<br class='over_display'>
    今後のビジョンなどについて、本音で語りました。">
      <LinkCard
        title="AI<br class='over_display'>
        データサイエンス領域<br class='over_display'>
        ×<br class='over_display'>
        若手社員"
        headline="「火星の大気データと、<br class='over_display'>
        金融機関の利用者のデータ。<br class='over_display'>
        実は、根本は同じなんですよ」"
        :image="require('../assets/home/image06.jpg')"
        :imageSp="require('../assets/home/image06_sp.jpg')"
        pageLink="/discussion_young" />

      <LinkCard
        title="エンタープライズ、<br class='over_display'>
        組込み領域<br class='over_display'>
        ×<br class='over_display'>
        マネージャー"
        headline="「そこに普遍的な何かを<br class='over_display'>
        見つけることによって、10年単位で<br class='over_display'>
        運用可能なシステムがつくられる」"
        :image="require('../assets/home/image07.jpg')"
        :imageSp="require('../assets/home/image07_sp.jpg')"
        pageLink="/discussion_mgr" />
    </PagesIntro> -->

		<div class="recruit_pitch">
			<iframe
				class="speakerdeck-iframe"
				frameborder="0"
				src="https://speakerdeck.com/player/517cdc8df49247819028052a3cc57149"
				title="株式会社豆蔵 会社紹介資料"
				allowfullscreen="true"
				mozallowfullscreen="true"
				webkitallowfullscreen="true"
				style="border: 0px; background: padding-box padding-box rgba(0, 0, 0, 0.1); margin: 0px; padding: 0px; border-radius: 6px; box-shadow: rgba(0, 0, 0, 0.2) 0px 5px 40px; width: 100%; height: 100%;"
				data-ratio="1.78343949044586"
			></iframe>
		</div>
		<div class="rss-container">
			<rssapp-wall id="EySYsZHaMbJ4MCWQ"></rssapp-wall>
		</div>
		<!-- 社員紹介制度 -->
		<SpecialCard
			title="社員紹介制度"
			subTitle="（リファラル採用）"
			:image="require('../assets/home/specialImg01.jpg')"
			:imageSp="require('../assets/home/specialImg01.jpg')"
			pageLink="/referral"
		/>
	</div>
</template>

<script>
// @ is an alias to /src
import News from '@/components/home/News.vue';
import PageIntro from '@/components/home/PageIntro.vue';
import PagesIntro from '@/components/home/PagesIntro.vue';
import LinkCard from '@/components/home/LinkCard.vue';
// import PageLinkButton from '@/components/common/PageLinkButton.vue';
import CardItems from '../components/home/CardItems.vue';
import SpecialCard from '../components/home/SpecialCard.vue';

export default {
	name: 'home',
	components: {
		News,
		PageIntro,
		PagesIntro,
		LinkCard,
		CardItems,
		SpecialCard,
	},
};
</script>

<style lang="scss">
.home {
	z-index: 1;
	position: relative;
}
.movie {
	width: 100%;
	video {
		width: inherit;
	}
}
.recruit_pitch {
	max-width: 90%;
	margin: 0 auto;
	@media print, screen and (min-width: 1161px) {
		max-width: 1200px;
	}
	iframe {
		width: 100%;
		aspect-ratio: 16 / 9;
	}
}
.rss-container {
	margin-top: 75px;
	background-color: #dddddd;
	padding: 60px 0;
	@media print, screen and (min-width: 1161px) {
		padding: 80px 0;
	}
	a {
		&:hover {
			opacity: 0.5;
		}
	}
}
</style>
